/**
 * Toca a amostra de UMA voz do catálogo — "ouvir antes de fixar" (spec-016,
 * [US-3]).
 *
 * Não reusa `_tocarUmAudio`/`reproduzirResposta` de `fala-da-ia.js` de
 * propósito: aqueles setam `motorDeVoz.estadoDaFala = 'ia'` (acende a orb,
 * como se a IA estivesse respondendo) e, ao terminar, podem reabrir o mic
 * sozinho (`_aoFilaEsvaziar`, o re-arme da conversa contínua) — os dois
 * efeitos pertencem à CONVERSA, e a amostra não é conversa (US-3 AC3: não
 * cria mensagem, não abre turno, não conta fala). Um `Audio` isolado, sem
 * tocar `motorDeVoz`, é o que garante isso por construção.
 */
export const tocarAmostra = (audioBase64, contentType) => {
  return new Promise((resolve) => {
    if (!audioBase64) {
      resolve()
      return
    }
    const tipo = contentType || 'audio/mpeg'
    const audio = new Audio('data:' + tipo + ';base64,' + audioBase64)
    const encerrar = () => resolve()
    audio.addEventListener('ended', encerrar)
    audio.addEventListener('error', encerrar)
    audio.play().catch(encerrar)
  })
}
